import React from 'react';
import PropTypes from 'prop-types';
import DoneSvg from './svg/DoneSvg';
import CurrentSvg from './svg/CurrentSvg';
// import PendingSvg from './svg/PendingSvg';

const StepperListItem = (props) => {
  return (
    <li className={"stepper__list__item stepper__list__item--" + props.type.toLowerCase()}>
      {{
        DONE: <DoneSvg />,
        CURRENT: <CurrentSvg />,
        PENDING: <DoneSvg />,
      }[props.type]}
      <span className="stepper__list__title">{props.title}</span>
    </li>
  );
};

StepperListItem.defaultProps = {
  type: 'PENDING',
  title: '-'
};

StepperListItem.propTypes = {
  type: PropTypes.oneOf(['DONE', 'CURRENT', 'PENDING']),
  title: PropTypes.string
};

export default StepperListItem;
